<div class="view-header" [class.no-banner]="embedService.embed">
  @if (job$ | async; as job) {
    <div class="view-header-content">
      @if (!embedService.embed) {
        <div class="links">
          <div class="left">
            <a class="icon" [routerLink]="refService.refCompany ? ['/companies', job.companyID] : ['/']">
              <fa-icon [icon]="fontawesomeService.regular.chevronLeft"></fa-icon>
            </a>
            @if (refService.refCompany) {
              <p class="d-none d-sm-block">
                {{ 'jobboard.views.job.back-button-jobs' | transloco }}
              </p>
            }
            @if (!refService.refCompany) {
              <p class="d-none d-sm-block">
                {{ 'jobboard.views.job.back-button-jobboard' | transloco }}
              </p>
            }
            <p class="d-block d-sm-none">{{ 'jobboard.views.job.back-button-sm' | transloco }}</p>
          </div>
          @if (!refService.refCompany && job?.companyID) {
            <div class="right">
              <a class="icon" [routerLink]="['/companies', job.companyID]">
                <fa-icon [icon]="fontawesomeService.regular.chevronRight"></fa-icon>
              </a>
              <p>{{ 'jobboard.views.job.more-jobs-button' | transloco }} {{ job.companyTitle }}</p>
            </div>
          }
        </div>
      }
      <h1>{{ job.jobTitle }}</h1>
      <div class="content">
        @if (!refService.refCompany && !embedService.embed) {
          <ul>
            <li>{{ job.companyTitle }}</li>
            @if (job?.website) {
              <li>
                <a [href]="job?.website" target="_blank">
                  {{ 'jobboard.static.header.website' | transloco }}
                  <fa-icon [icon]="fontawesomeService.regular.externalLink"></fa-icon>
                </a>
              </li>
            }
          </ul>
        }
        <div class="description">
          <app-header-tags
            [startDate]="job.startDate"
            [employmentType]="job.employmentType"
            [workingTime]="job.workingTime"
            [locations]="job.workLocations"
            [workingModel]="job.workingModel"
            [searchRegionAddress]="job.searchRegionAddress"
            [showSalaryRangeOnJobboard]="job.showSalaryRangeOnJobboard ?? false"
            [salaryCurrency]="job.currency"
            [salaryMin]="job.salaryMin"
            [salaryMax]="job.salaryMax"
            [fallbackSalary]="job.salary"
            [salaryInterval]="job.salaryInterval"
          ></app-header-tags>
          @if (job?.open) {
            <div class="apply">
              <a
                [routerLink]="['apply']"
                [target]="embedService.embed ? '_blank' : null"
                class="ct-btn ct-btn-themed-solid apply-btn"
                >
                {{ 'jobboard.views.job.apply-now' | transloco }}
              </a>
            </div>
          }
        </div>
      </div>
    </div>
  }
</div>
@if (job$ | async; as job) {
  <div class="view-content">
    <h1>{{ job.jobTitle }}</h1>
    <div class="view-section">
      @if (!job?.open) {
        <ct-lib-inline-info>
          <p>{{ 'jobboard.views.job.closed-info' | transloco }}</p>
        </ct-lib-inline-info>
      }
      <ct-lib-markdown-viewer [value]="job.description"></ct-lib-markdown-viewer>
      @if (job?.open) {
        <div class="apply">
          <a
            [routerLink]="['apply']"
            [target]="embedService.embed ? '_blank' : null"
            class="ct-btn ct-btn-themed-solid apply-btn"
            >
            {{ 'jobboard.views.job.apply-now' | transloco }}
          </a>
        </div>
      }
    </div>
  </div>
}
